export default "__VITE_ASSET__DhUB4cID__"